import { render, staticRenderFns } from "./addActile.vue?vue&type=template&id=5ca5728d&scoped=true&"
import script from "./addActile.vue?vue&type=script&lang=js&"
export * from "./addActile.vue?vue&type=script&lang=js&"
import style0 from "./addActile.vue?vue&type=style&index=0&id=5ca5728d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca5728d",
  null
  
)

export default component.exports